module.exports = __webpack_public_path__ + "media/images/webpage/logo/logo-icotto-90274d8452464aa83c385ca1ba497472.svg";